<template>
	<section class="small-12 questions flex justify-center">
        <div class="small-12 large-10 columns">
            <div class="small-12 questionsSection">
                <div class="small-12 columns title flex justify-center">
                    <h2>Section Title Here</h2>
                </div>
                <div class="small-12 sectionContent">
                    <ul class="small-12 flex float-left">
                        <li class="small-12 large-4 columns" v-for="(question, index) in 12" :key="index">
                            <div class="small-12 questionTitle">
                                <h6>What is Nestd?</h6>
                            </div>
                            <div class="small-12 answer">
                                <p>
                                    It is a long established fact that a reader will be 
                                    distracted by the readable content of a page when 
                                    looking at its layout. The point of using Lorem Ipsum 
                                    is that it has a more-or-less normal distribution of 
                                    letters, as opposed to using 'Content here, content here', 
                                    making it look like readable English.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

	// Import firebase
	import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'FaqQuestions',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			//

		}),

		/*
		**  Watch em'
		*/

		watch: {

			prop_name_here: {

				immediate: true, // Load on created
				handler(value) {

					//

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>